<template>
  <div id="app">
    <Notifications />
    <TheNotifications />
    <router-view/>
    <SessionInactivityModal
      v-if="sessionWarningVisible"
      :active="sessionWarningVisible"
      @continue-session="continueSession"
      @close-session="doLogout"
      @countdown-finished="doLogout"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import jwtDecode from 'jwt-decode'
import inactivityManager from '@/utils/inactivityManager'

export default {
  components: {
    TheNotifications: () => import('@/components/ui/TheNotifications.vue'),
    Notifications: () => import('@/components/ui/Notifications.vue'),
    SessionInactivityModal: () => import('@/components/ui/modals/SessionInactivityModal.vue')
  },
  head () {
    return {
      title: 'My page title',
      meta: [
        { name: 'description', content: 'My page description' }
      ]
    }
  },
  data () {
    return {
      sessionWarningVisible: false
    }
  },
  watch: {
    $route (to) {
      if (to.name === 'login' || to.path === '/login') {
        inactivityManager.destroy()
        this.sessionWarningVisible = false
      }
    }
  },
  methods: {
    ...mapMutations(['loginSuccess']),
    islogged () {
      const accessToken = localStorage.getItem('access-token')
      if (accessToken) {
        const payload = jwtDecode(accessToken)
        this.loginSuccess({ ...payload, token: accessToken })
      }
    },
    initInactivityManager (minutes) {
      inactivityManager.init({
        inactivityMinutes: minutes,
        onShowWarning: () => { this.sessionWarningVisible = true },
        onDismissWarning: () => { this.sessionWarningVisible = false },
        onLogout: () => this.doLogout()
      })
    },
    continueSession () {
      inactivityManager.continueSession()
      this.sessionWarningVisible = false
    },
    _tryStartInactivity () {
      if (!localStorage.getItem('access-token')) return
      const auth = this.$store.state.authentication
      const minutes = auth?.role?.configuration?.inactivityTimeMinutes
      if (minutes === null || minutes === 0) {
        inactivityManager.destroy()
        this.sessionWarningVisible = false
        return
      }
      if (inactivityManager._active) return
      this.initInactivityManager(minutes)
    },
    async doLogout () {
      inactivityManager.destroy()
      this.sessionWarningVisible = false
      await this.$store.dispatch('logout')
      // const authBase = `${process.env.VUE_APP_PROTOCOL}://localhost${process.env.VUE_APP_AUTH}`
      window.location.replace('/login?reason=inactivity')
    }
  },
  mounted () {
    this.islogged()
    window.__inactivityShowWarning = () => { this.sessionWarningVisible = true }
    window.__inactivityDismissWarning = () => { this.sessionWarningVisible = false }
    window.__inactivityLogout = () => this.doLogout()
    this._tryStartInactivity()
  },
  beforeDestroy () {
    inactivityManager.destroy()
  }
}
</script>
